import {Component, OnInit} from '@angular/core';
import { GlobalServiceService } from '../global-service.service';


@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css'],
})
export class SkillsComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.291;
  fired: boolean = false;

  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    this.height = this.service.getHeight(this.proportion);
  }

  onScroll(){
    let inScroll = SkillsComponent.isElementInViewport($('.container'));
    if (inScroll == true){
      if (!this.fired){
        this.fireAnimation();
      }
      this.fired = true;
    }
  }

  fireAnimation(){
   this.setClouds();
   this.setLines();
   this.setPercents();
  }

  setClouds(){
    $('.percent-cloud:nth-child(1)').addClass('ninetyOne');
    $('.percent-cloud:nth-child(2)').addClass('ninetyFive');
    $('.percent-cloud:nth-child(3)').addClass('eighty-nine');
    $('.percent-cloud:nth-child(4)').addClass('ninetyThree');
    $('.percent-cloud:nth-child(5)').addClass('ninetyOne');
  }

  setLines() {
    $('.one').addClass('line-animation-one');
    $('.two').addClass('line-animation-two');
    $('.three').addClass('line-animation-three');
    $('.four').addClass('line-animation-four');
    $('.five').addClass('line-animation-five');
}

  setPercents(){
      this.numberAnimation($('.percent-cloud:nth-child(1) p'), 94);
    this.numberAnimation($('.percent-cloud:nth-child(2) p'), 98);
    this.numberAnimation($('.percent-cloud:nth-child(3) p'), 95);
    this.numberAnimation($('.percent-cloud:nth-child(4) p'), 93);
    this.numberAnimation($('.percent-cloud:nth-child(5) p'), 94);
    }

    numberAnimation(el: any, percent : number) {
      let i = 0;
      setInterval(function() {
        i++;
        if (i < percent) {
            el.text(i + '%');
          }
      }, 10);
   }



  static isElementInViewport (el) {

  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }

  let rect = el.getBoundingClientRect();

   return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || $(window).height()) &&
    rect.right <= (window.innerWidth || $(window).width())
   );
  };
}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/homepage/skills.component.ts